// src/components/utilities/SwalService.js
import Swal from 'sweetalert2'

export async function confirmAction({ isDark = false, ...customOptions }) {
  const defaultOptions = {
    animation: false,
    showCancelButton: true,
    buttonsStyling: false,
    reverseButtons: true,
    background: isDark ? '#1e1e1e' : '#fff',
    color: isDark ? '#f5f5f5' : '#222',
    customClass: {
      popup: isDark ? 'swal2-dark' : '',
      container: isDark ? 'dark' : 'light',
      confirmButton:
        'v-btn v-btn--contained theme--dark v-size--default v-btn--depressed',
      cancelButton:
        'v-btn v-btn--contained theme--dark v-size--default v-btn--depressed',
    },
    // confirmButtonClass:
    //   'v-btn v-btn--contained theme--dark v-size--default v-btn--depressed',
    // cancelButtonClass:
    //   'v-btn v-btn--contained theme--dark v-size--default v-btn--depressed',
  }

  const finalOptions = {
    ...defaultOptions,
    ...customOptions,
    customClass: {
      ...defaultOptions.customClass,
      ...(customOptions.customClass || {}),
    },
  }

  const result = await Swal.fire(finalOptions)
  return result.isConfirmed
}
